import { ProspectKey } from '../prospect.key';

export enum ProspectInformationsKey {
  ATTRIBUTION = ProspectKey.VENDOR,
  SOURCE = 'prospect_source',
  QUALIFICATION = ProspectKey.QUALIFICATION,
  METIER = ProspectKey.METIER,
  BESOIN = ProspectKey.BESOIN,
  INTERVENTION = ProspectKey.INTERVENTION,
  STATUT = ProspectKey.STATUT,
  DATE = ProspectKey.DATE,
  ID = ProspectKey.ID,
  ACCOUNT = ProspectKey.ACCOUNT,
  COMMENT = 'prospect_comments',
  NAME = 'prospect_name',
  COMPANY = 'prospect_company',
  EMAIL = 'prospect_email',
  MOBILE = 'prospect_mobile',
  PHONE = 'prospect_phone',
  NUMBER = 'prospect_number',
  POSTAL_CODE = 'prospect_postal',
  OPT_IN = 'prospect_optin',
  REFERENCE = 'prospect_ref',
  UPDATED = 'prospect_updated',
  CREATED = 'prospect_created',
  CIVILITY = 'prospect_civility',
  FIRSTNAME = 'prospect_firstname',
  LASTNAME = 'prospect_lastname',
  ID_SOURCE = 'source_id',
  ID_ACCOUNT = 'account_id',
}

export enum ProspectInformationRequestKey {
  ID = ProspectKey.ID,
  WITH_AI = 'with_ai',
}
